import $ from 'jquery'
import VoirResultat from '@/views/analyse/visualiser-resultat';
import ResultatPatientModal from '@/views/analyse/registre_analyse/resultat-patient-modal'

import RegistrePatient from '@/views/analyse/registre_analyse/registre-patient'
import ResultatPatient from '@/views/analyse/registre_analyse/resultat-patient'
import GroupedAnalysisResultsPDF from '@/views/analyse/registre_analyse/components/GroupedAnalysisResultsPDF'
import DateFilter from '@/components/date-filter';
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import EditAnalyse from '@/views/analyse/registre_analyse/edit-analyse'

import store_analyse from '@/store/mods/analyses/analyse'
import store_patients from '@/store/mods/patients/patient'

export default {
    name: 'registre-analyse',
    components: {
        VoirResultat, EditAnalyse,
        RegistrePatient, DateFilter, ResultatPatientModal, 
        ResultatPatient, EnteteBonEtFacture, GroupedAnalysisResultsPDF
    },
    props: [],
    data() {
        return {
            isResultsLoading: false,
            is_loading: true,
            is_empty: false,

            liste_analyse_filtre: [],
            fields: [
                'patient', { key: 'age', label: 'Âge' }, 'sexe', 'date', { key: 'statut', label: 'Statut' }, 
                { key: 'action', label: 'Action.s' }
            ],
			filter: [],
			perPage: 25,
			currentPage: 1,

            filtre_resultat: {
                analyse_id: 0,
                analyse: 'Tous'
            },

            result_preview: {},
            results: null,
            selectedPatient: undefined,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            liste_registre_analyse: [],
            can_print: false,
            can_print_grouped: false,
            view_result_loading: false,
            toggler: 0,

            add_result_loading: false,
            result_meta_data: {
                patient_fullname: '',
                patient_age: '',
                patient_gender: '',
                patient_phone: '',
                doctor_fullname: '',
                clinical_inquiries: '',
                methodology_applied: '',
            },
            demande_id: 0,
            selected_analyse: '',
            has_model: false,
            liste_patients: [],
            l_patient_loading: false,
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
            }
            this.current_date_filter = data
            this.is_month = true
            this.getRegistreAnalyse(data)
        },

        selectedPatient: function (newVal) {
            if (newVal !== undefined) {
                this.filtre_resultat = undefined
            }
        },
        
        filtre_resultat: function (newVal) {
            if (newVal !== undefined) {
                this.selectedPatient = undefined
            }
        }
    },

    computed: {
        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            var m = []
            for (index = 0; index <= this.current_date.getMonth() + 1; index++) {
                m[index] = this.list_months[index];
            }
            return m;
        },

        showPatientSection() {
            return this.selectedPatient !== undefined && this.filtre_resultat === undefined;
        },

        patients() {
            return this.$store.getters['patients']
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        current_modele_analyse() {
            return this.$store.getters.current_modele_analyse
        },

        modeles_analyses() {
            return this.$store.getters["modeles_analyses"];
        },

        // resultats_analyses() {
        //     return this.$store.getters.resultatsAnalyse
        // },
    },

    mounted() {
        // this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
        this.$store.commit("SET_TSL_FILTER_DATE", {});
        this.$store.commit("SET_RESULTATS_ANALYSE", null);
        this.$store.commit("SET_PATIENTS", []);

        this.fetchListePatients()

        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.getRegistreAnalyse(data)
    },

    methods: {
        fetchListePatients() {
            this.l_patient_loading = true
            store_patients.getListePatients().then((response) => {
                this.liste_patients = response

                this.l_patient_loading = false
            })
        },

        refreshRegistre() {
            this.getRegistreAnalyse(this.current_date_filter)
        },

        getRegistreAnalyse(data) {
            this.is_loading = true
            store_analyse.getRegistreAnalyse(data).then((registre) => {
                this.liste_registre_analyse = registre
                if (this.liste_registre_analyse.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
    
                let select_all = {
                    analyse_id: 0,
                    analyse: 'Tous'
                }
                this.liste_analyse_filtre.push(select_all)
    
                this.liste_registre_analyse.forEach(element => {
                    let t = {
                        analyse_id: element['analyse_id'],
                        analyse: element['analyse']
                    }
                    this.liste_analyse_filtre.push(t)
                });
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getRegistreAnalyse(data)
        },

        onFilterTarif() {
			let id_selected = this.filtre_resultat?.analyse_id
            
			if (id_selected > 0) {
                $('.shw-result').fadeOut(500)
				setTimeout(() => {
					$('.result-anl-'+id_selected).fadeIn()
				}, 500);
			} else {
				$('.shw-result').fadeIn(500)
			}
		},

        async previewResultExamen(demande_analyse, item) {
            if (demande_analyse.analyse != 'TDR Malaria') {
                this.view_result_loading = true

                if (this.is_modele_analyse) {
                    if (item.etat_resultat == 1 && item.resultat == null) {
                        $("#view-analysis-modal").modal('show');
        
                        const param = {
                            analyseId: demande_analyse.analyse_id,
                            bulletinId: item.bulletin_id
                        }
                        store_analyse.getResultatAnalysePatient(param).then((response) => {
                            this.results = response;
                            this.view_result_loading = false
                        })
                    } else {
                        const demande = {
                            analyse_nom: demande_analyse.analyse,
                            resultat_fichier: item.resultat,
                            commentaires: item.interpretation
                        }
                        this.result_preview = demande
        
                        $('.visualiser-resultat .modal').modal('show');
                    }
                } else {
                    const demande = {
                        analyse_nom: demande_analyse.analyse,
                        resultat_fichier: item.resultat,
                        commentaires: item.interpretation
                    }
                    this.toggler = (this.toggler == 0)?1:0
                    this.result_preview = demande

                    $('.visualiser-resultat .modal').modal('show');
                }
            }
        },

        getPatientName({ nom, prenoms }) {
            return `${nom} ${prenoms}`;
        },

        redirectTo(analyse_id){
            this.$store.commit("SET_TSL_FILTER_DATE", this.current_date_filter);

            this.$router.push({path:'/analyses/registre-others/'+analyse_id})
        },

        printResultatAnalyse(results) {
            this.results = results
            this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 1500);
        },

        printGroupedResult(results) {
            this.results = results
            this.can_print_grouped = true
            setTimeout(() => {
                window.print()

                this.can_print_grouped = false
            }, 1500);
        },

        selectModeleAnalyse(modele) {
            this.$store.dispatch('setModeleAnalyse', modele);
            this.$bvModal.hide(`model-list-modal-${this.demande_id}`);

            const saisie_results = {
                data: this.setEditableFields(modele.meta.rows),
                model_analyse_id: this.current_modele_analyse.id,
            }

            this.$store.dispatch("setPatientMetaData", this.result_meta_data);
            this.$store.dispatch("setResultatsAnalyse", saisie_results);
        },

        setResultToEdit(data, bulletin_info) {
            this.add_result_loading = true
            
            // this.result_to_fill = {
            //     demande_id: demande.demande_id,
            //     analyse_nom: demande.nom,
            //     analyse_commentaire: demande.commentaires
            // }

            this.result_meta_data = {
                patient_id: bulletin_info.patient_id,
                patient_fullname: bulletin_info.patient,
                patient_age: bulletin_info.age,
                patient_gender: bulletin_info.sexe,
                patient_phone: bulletin_info.telephone,
                doctor_fullname: bulletin_info.medecin_demandeur.medecin_nom,
                clinical_inquiries: bulletin_info.renseignement_clinique,
                methodology_applied: data.technique_utilisee,
                bulletin_analyse_id: bulletin_info.bulletin_id,
            }
            this.demande_id = bulletin_info.demande_id
            this.selected_analyse = data.analyse

            this.$store.dispatch("setPatientMetaData", this.result_meta_data);
            
            this.$store.commit("SET_ADD_RESULT_LOADER", true);
            this.$store.dispatch('fetchModelesAnalyses', { analyse_id: data.analyse_id, status: 'active' }).then(() => {
                this.$store.dispatch("setResultatsAnalyse", null);//Réinitialisation des resultats
                
                this.has_model = true
                
                if (this.modeles_analyses.length === 0) {
                    this.has_model = false
                    this.$store.commit("SET_ADD_RESULT_LOADER", false);
                    $('#saisie-resultats-analyse-modal-' + this.demande_id).modal('show');
                    
                    return;
                }

                const param = {
                    analyseId: data.analyse_id,
                    bulletinId: bulletin_info.bulletin_id
                }
                
                $('#saisie-resultats-analyse-modal-' + this.demande_id).modal('show');
                this.$store.dispatch("getResultsByAnalyseIdBulletinId", param).then((response) => {
                    // this.$store.commit("SET_ADD_RESULT_LOADER", false);
                    this.add_result_loading = false
                    if (response.data.data?.length > 0) {
                        this.$store.dispatch('setModeleAnalyse', this.modeles_analyses[0])
                        this.$store.dispatch("setResultsMode", 'edit');
                        
                        this.selectModeleAnalyse(this.modeles_analyses[0])
                        
                        this.$store.dispatch('setResultatsAnalyse', response.data)
                    }
                }) 
            })
        },

        setEditableFields(modele_rows) {
            const rows = modele_rows;
            rows.forEach(row => {
                row.cells.forEach((cell, cellIndex) => {
                    if (this.resultats_analyses === null && (cell.value === null || cell.value === '')) {
                        cell.editable = cellIndex !== 0 ? true : false;
                        if (cell.subcells && cell.subcells.length > 0) {
                            cell.subcells.forEach(subcell => {
                                if (subcell.value === null || subcell.value === '') {
                                    subcell.editable = true;
                                } else {
                                    subcell.editable = cellIndex !== 0 ? true : false;
                                }
                            });
                        }
                    } else {
                        cell.editable = false;
                        if (cell.subcells && cell.subcells.length > 0) {
                            cell.subcells.forEach(subcell => {
                                subcell.editable = false;
                            });
                        }
                    }
                });
            });

            return rows;
        },
    }
}